export const API_LOGIN = "/auth/login";
export const API_REGISTER = "/auth/register";
export const API_LOGOUT = "/users/logout";

export const API_AUTH_SEND_AUTH_CODE = "/auth/send-auth-code";
export const API_AUTH_CHANGE_PASSWORD = "/auth/change-password";
export const API_AUTH_SSO = "/auth/sso";

export const API_CLIENT_CRASH = "/clients/crash";
export const API_ENUMS = "/enums";

export const API_USER_ME = "/users/me";
export const API_USER_CHANGE_PASSWORD = "/users/change-password";

export const API_PATENT = "/patents";
export const API_PATENT_LIST = "/patents/my-list";
export const API_PATENT_LIST_BY_OPEN_API = "/patents/list-by-open-api";
export const API_PATENT_ADD_BY_OPEN_API = "/patents/add-by-open-api";
export const API_PATENT_ADD_BY_OPEN_API_TASK = "/patents/add-by-open-api-task";
export const API_PATENT_TREE = "/patents/my-tree";
export const API_PATENT_UNFOLLOW = "/patents/unfollow";
export const API_PATENT_FILTER_OPTIONS = "/patents/user-filter-options";
export const API_PATENT_AUTO_MONITOR = "/patents/auto-monitor";
export const API_PATENT_SALES_NAME = "/patents/sales-name";

export const API_LIST_LAYOUT = "/list-layouts";

// export const API_EXPORT_TASK = "/exports/tasks";
export const API_EXPORT_TASK_SYNC = "/exports/tasks/sync";

export const API_REMIND = "/reminds";
export const API_REMIND_TREE = "/reminds/tree";
export const API_REMIND_LIST = "/reminds/list";
export const API_REMIND_MY_LIST = "/reminds/my-list";
export const API_REMIND_READ = "/reminds/read";
export const API_REMIND_UN_READ_COUNTS = "/reminds/un-read-counts";
export const API_REMIND_PUSH_LIST = "/reminds/push-list";

export const API_OPENED_SYSTEM_INFO = "/opened/system-info";
export const API_OPENED_WEB_NOTICE = "/opened/web-notice";
export const API_OPENED_ORG_INFO = "/opened/org-info";
export const API_OPENED_WEIXIN_API = "/opened/weixin-api";
